import React from 'react'
import { Section } from '@alto-avios/alto-ui'
import { RichText } from '~/components/contentful/ContentfulRichText'
import { SearchTabQuery } from '~/schemas/searchPageParams'
import { MediaCard } from '~/components/search-and-results/Card'

import { ContentfulIntroSection } from '@reward-platform/contentful'
import styles from './IntroSection.module.scss'

type Props = {
  sectionContent: ContentfulIntroSection
  product: SearchTabQuery
}

const IntroSection = ({ sectionContent: { content, cards = [] }, product }: Props) => {
  return (
    <Section alignItems="flexStart" flexDirection="column" justifyContent="flexStart">
      <Section.Container className={styles.container}>
        {content && (
          <div className={styles.content}>
            <RichText document={content} />
          </div>
        )}
        <div className={styles.scroller} data-testid="section-intro">
          {cards?.map((item) => (
            <MediaCard key={JSON.stringify(item)} card={item} product={product} />
          ))}
        </div>
      </Section.Container>
    </Section>
  )
}

export default IntroSection
